/**
 * Global site configuration.
 * SITE_URL is the canonical production origin used for SEO (canonical tags,
 * Open Graph, sitemap). It resolves from REACT_APP_SITE_URL so it stays correct
 * regardless of which domain serves the app; it must NEVER be the preview URL.
 */
export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || "https://www.farmsons.co.in"
).replace(/\/$/, "");

export const SITE_NAME = "Farmsons";
export const CONTACT_EMAIL = "zahidshamim@farmsons.co.in";
export const LINKEDIN_URL = "https://www.linkedin.com/in/zahid-shamim/";

/** Primary navigation. `Ventures` is a dropdown of the three vertical pages. */
export const NAV = [
  {
    label: "Ventures",
    dropdown: [
      { label: "Fruit Trading", to: "/fruit-trading" },
      { label: "Rootstock Import & Distribution", to: "/rootstock" },
      { label: "Mango Export", to: "/mango-export" },
    ],
  },
  { label: "Story", to: "/about" },
  { label: "Sourcing", to: "/sourcing" },
  { label: "Partners", to: "/partners" },
  { label: "Quality", to: "/quality" },
  { label: "Insights", to: "/insights" },
  { label: "Contact", to: "/contact" },
];

/** Flat list of every routable page — used to generate the sitemap reference. */
export const ROUTES = [
  "/", "/about", "/fruit-trading", "/rootstock", "/mango-export",
  "/sourcing", "/partners", "/quality", "/insights", "/contact",
];
